module.exports = __webpack_public_path__ + "img/BARRY.10cc45ce.png";